import { Button, Container, Typography } from "@mui/material";
import { Link, useRouteError } from "react-router-dom";

import styles from "./ErrorPage.module.css";

export const ErrorPage = () => {
    // Hooks
    const error = useRouteError();

    // Consts
    const message = error instanceof Error ? error.message : "Unknown error";

    return (
        <Container className={styles.page}>
            <Typography variant="h3" component="h1" gutterBottom>
                Something went wrong
            </Typography>
            <Typography color="text.secondary">{message}</Typography>
            <div className={styles.actions}>
                <Button component={Link} to="/" variant="contained">
                    Go home
                </Button>
            </div>
        </Container>
    );
};
